import Vue from 'vue';
import App from './App.vue';
import global from './mixins/global';
import './registerServiceWorker';
import router from './router';
import store from './store';
// Vuetify UI library
import vuetify from '@/plugins/vuetify'; // path to vuetify export
// Meta tag
import VueMeta from 'vue-meta';
import VTooltip from 'v-tooltip';
// import VueToast from 'vue-toast-notification';
import moment from 'moment';
// import 'vue-toast-notification/dist/theme-sugar.css';
import VueTour from 'vue-tour';

require('vue-tour/dist/vue-tour.css');

Vue.use(VueTour);
Vue.use(VTooltip);
// Vue.use(VueToast);

Vue.config.productionTip = false;
// Vue.use(vueMentionable);
Vue.mixin(global);

Vue.use(VueMeta, {
	// optional pluginOptions
	refreshOnceOnNavigation: true,
});

router.beforeEach(async (to, from, next) => {
	const requiresAuth = to.matched.some(x => x.meta.isAuthRequire);
	let loggedUser = JSON.parse(localStorage.getItem('authUser'));
	let now = moment.utc(new Date());
	let isOK = false;
	if (loggedUser) {
		let expiry = await moment.unix(loggedUser.subscription_plan.expiry);
		expiry = await moment.utc(expiry);
		isOK = expiry.isAfter(now);
	}
	if (loggedUser && loggedUser.isCompleted == false) {
		if (to.name == 'Profile' && to.query.completeProfile == 'true') next();
		else next('/profile?completeProfile=true');
	} else if (loggedUser && isOK == false && to.name != 'Resubscribe') {
		next('/resubscribe');
	} else if (to.name == 'Login' && loggedUser) {
		next('/dashboard');
	} else if (requiresAuth && !loggedUser) {
		next('/login');
	} else {
		next();
	}
});

new Vue({
	router,
	vuetify,
	store,
	render: h => h(App),
}).$mount('#app');
